import {
  Component,
  Input
} from '@angular/core';

@Component({
	selector    : 'manage-shared-list',
	templateUrl : 'manage-shared-list.html',
	styleUrls   : [ 'manage-shared-list.scss' ]
})

export class ManageSharedListComponent {
  @Input() sharedList;

  // constructor() {}
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/manage-shared-list/manage-shared-list.ts